function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe",
    ),
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open"),
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open"),
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true,
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*",
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this)),
    );

    if (this.input.value <= 1) {
      this.querySelector('[name="minus"]').setAttribute("disabled", "disabled");
    } else {
      this.querySelector('[name="minus"]').removeAttribute("disabled");
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.input.value <= 1) {
      this.querySelector('[name="minus"]').setAttribute("disabled", "disabled");
    } else {
      this.querySelector('[name="minus"]').removeAttribute("disabled");
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options,
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid,
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this),
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this)),
    );
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this)),
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary"),
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button"),
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus,
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty(
          "--viewport-height",
          `${window.innerHeight}px`,
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              "transitionend",
              addTrapFocus,
            );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`,
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary"),
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom",
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset,
      )}px`,
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false),
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(
          true,
        ),
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe"),
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0,
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset,
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        }),
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1],
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link"),
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this)),
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this),
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active",
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true,
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed,
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow,
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow,
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    /*
    if (
      this.dataset.url == "/products/perception" ||
      this.dataset.url == "/products/ancestra-jiao" ||
      this.dataset.url == "/products/inflection"
    )
      */
    if (
      window.ShopifyTemplate.suffix === "perception" ||
      window.ShopifyTemplate.suffix === "ancestra" ||
      window.ShopifyTemplate.suffix === "inflection" ||
      window.ShopifyTemplate.suffix === "perception-v3"
    ) {
      window.addEventListener("message", (event) => {
        let data = event.data;

        if (typeof data === "string") {
          try {
            data = JSON.parse(data);

            if (data.iframeStates == "SUCCESS") {
              this.update3DModel();
            }
          } catch {
            return;
          }
        }
      });
    }
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();

      if (window.ShopifyTemplate.suffix === "inflection") {
        this.dispatchEvent(
          new CustomEvent("inflection:variant-change", {
            detail: { variant: this.currentVariant },
          }),
        );
      }

      this.updateVideoState();

      //if (this.dataset.url == "/products/perception") {
      if (window.ShopifyTemplate.suffix === "perception") {
        this.updatePerceptionFront();
        this.updatePerceptionMailForm();
      }

      this.updateMedia();

      //if (this.dataset.url != "/products/inflection") {
      if (
        window.ShopifyTemplate.suffix !== "inflection" ||
        window.ShopifyTemplate.suffix !== "inflection-shuo"
      ) {
        this.updateStickyAtc();
      } else {
        this.updateInflectionMedia();
        this.updateInflectionStickyAtc();
        this.updateInflectionTitle();
        this.updateInflectionMailForm();
        this.updateInflectionStrapDropdown();
        //this.updateInflectionPrice();
        this.updateInflectionTantalumBasedPrice();
        this.updateInflectionSoldout();
      }

      if (window.ShopifyTemplate.suffix === "perception-v3") {
        this.updatePerceptionV3Info();
        this.updatePerceptionV3Price();
        this.dispatchEvent(
          new CustomEvent("perception-v3:variant-change", {
            detail: { variant: this.currentVariant },
          }),
        );
      }

      if (window.ShopifyTemplate.suffix === "inflection-shuo") {
        this.updatePrice();
        this.updateInflectionShuoMedia();
        this.updateInflectionShuoStickyAtc();
        this.updateInflectionShuoStrapDropdown();
        this.updateInflectionShuoFormText();
      }
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value,
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  update3DModel() {
    //console.log(window.ShopifyTemplate.suffix);

    if (window.ShopifyTemplate.suffix === "perception") {
      //if (this.dataset.url == "/products/perception") {
      const iframe = document.getElementById("iframe-slide");
      const currentDial = this.currentVariant.title;
      let currentDialColor = "";

      if (currentDial.includes("Piao")) {
        currentDialColor = "Piao";
      } else if (currentDial.includes("Xia")) {
        currentDialColor = "Xia";
      } else {
        currentDialColor = "Ying";
      }

      if (iframe != null) {
        iframe.contentWindow.postMessage({ switchDial: currentDialColor }, "*");
      }
    }

    if (window.ShopifyTemplate.suffix === "ancestra") {
      //if (this.dataset.url == "/products/ancestra-jiao") {
      const iframe = document.getElementById("iframe-slide");
      const currentDial = this.currentVariant.title;
      let currentDialLanguage = "";

      if (currentDial.includes("Chinese")) {
        currentDialLanguage = "Chinese";
      } else {
        currentDialLanguage = "Arabic";
      }

      if (iframe != null) {
        iframe.contentWindow.postMessage(
          { switchDial: currentDialLanguage },
          "*",
        );
      }
    }

    if (window.ShopifyTemplate.suffix === "inflection") {
      //if (this.dataset.url == "/products/inflection") {
      const iframe = document.getElementById("iframe-slide");

      const currentDial = this.currentVariant.title.split(" / ")[0];
      const currentStrap = this.currentVariant.title.split(" / ")[1];

      let currentDialColor = "";
      let currentStrapColor = "";

      if (currentDial.includes("Green")) {
        currentDialColor = "You";
      } else if (currentDial.includes("Black")) {
        currentDialColor = "Mo";
      } else if (currentDial.includes("Blue")) {
        currentDialColor = "Yuan";
      }

      if (currentStrap.includes("Bracelet")) {
        currentStrapColor = "bracelet";
      } else if (currentStrap.includes("Green")) {
        currentStrapColor = "rubbergreen";
      } else if (currentStrap.includes("Blue")) {
        currentStrapColor = "rubberblue";
      } else if (currentStrap.includes("Grey")) {
        currentStrapColor = "rubbergrey";
      }

      if (iframe != null) {
        iframe.contentWindow.postMessage(
          { switchDial: currentDialColor, switchStrap: currentStrapColor },
          "*",
        );
      }
    }

    if (window.ShopifyTemplate.suffix === "perception-v3") {
      const iframe = document.getElementById("iframe-slide");
      const currentDial = this.currentVariant.title;
      let currentDialColor = "";

      if (currentDial.includes("Yun") || currentDial.includes("Yún")) {
        currentDialColor = "Yun";
      } else if (currentDial.includes("Piao") || currentDial.includes("Piāo")) {
        currentDialColor = "Piao";
      } else {
        currentDialColor = "Xia";
      }

      if (iframe != null) {
        iframe.contentWindow.postMessage(
          { switchDial: currentDialColor, switchStrap: "bracelet" },
          "*",
        );
      }
    }

    if (window.ShopifyTemplate.suffix === "inflection-shuo") {
      const iframe = document.getElementById("iframe-slide");
      const currentDial = this.currentVariant.title;
      let currentDialColor = "";

      if (currentDial.includes("Rose")) {
        currentDialColor = "RG";
      } else if (currentDial.includes("Silver")) {
        currentDialColor = "WG";
      } else {
        currentDialColor = "RG";
      }

      if (iframe != null) {
        iframe.contentWindow.postMessage(
          { switchDial: currentDialColor, strap: "bracelet" },
          "*",
        );
      }
    }
  }

  updateMedia() {
    /*
    if (!this.currentVariant) return;

    // Get Variant Index
    const currentId = this.currentVariant.id;
    const idx = this.variantData.findIndex((item) => item.id === currentId);

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );

    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.id}"]`
    );
    modalContent.prepend(newMediaModal);
    */

    const emblaContainer = document.getElementById("embla-main");

    const currentId = this.currentVariant.id;
    const idx = this.variantData.findIndex((item) => item.id === currentId);

    if (emblaContainer != null) {
      const evt = new CustomEvent("embla:reinit", {
        detail: { variantIndex: idx },
      });

      emblaContainer.dispatchEvent(evt);
    }

    this.update3DModel();
  }

  updateInflectionMedia() {
    const emblaContainer = document.getElementById("embla-main");

    const currentId = this.currentVariant.id;
    const idx = this.variantData.findIndex((item) => item.id === currentId);

    if (emblaContainer != null) {
      const evt = new CustomEvent("embla:reinit", {
        detail: { variantIndex: idx },
      });

      emblaContainer.dispatchEvent(evt);
    }

    const iframe = document.getElementById("iframe-slide");

    const currentDial = this.currentVariant.title.split(" / ")[0];
    const currentStrap = this.currentVariant.title.split(" / ")[1];

    let currentDialColor = "";
    let currentStrapColor = "";

    if (currentDial.includes("Green")) {
      currentDialColor = "You";
    } else if (currentDial.includes("Black")) {
      currentDialColor = "Mo";
    } else if (currentDial.includes("Blue")) {
      currentDialColor = "Yuan";
    }

    if (currentStrap.includes("Bracelet")) {
      currentStrapColor = "bracelet";
    } else if (currentStrap.includes("Green")) {
      currentStrapColor = "rubbergreen";
    } else if (currentStrap.includes("Blue")) {
      currentStrapColor = "rubberblue";
    } else if (currentStrap.includes("Grey")) {
      currentStrapColor = "rubbergrey";
    }

    if (iframe != null) {
      iframe.contentWindow.postMessage(
        { switchDial: currentDialColor, switchStrap: currentStrapColor },
        "*",
      );
    }
  }

  updateInflectionShuoMedia() {
    const emblaContainer = document.getElementById("embla-main");

    const currentId = this.currentVariant.id;
    const idx = this.variantData.findIndex((item) => item.id === currentId);

    if (emblaContainer != null) {
      const evt = new CustomEvent("embla:reinit", {
        detail: { variantIndex: idx },
      });

      emblaContainer.dispatchEvent(evt);
    }

    const iframe = document.getElementById("iframe-slide");

    const currentDial = this.currentVariant.title.split(" / ")[0];
    const currentStrap = this.currentVariant.title.split(" / ")[1];

    let currentDialColor = "";
    let currentStrapColor = "";

    if (currentDial.includes("Rose")) {
      currentDialColor = "RG";
    } else if (currentDial.includes("White")) {
      currentDialColor = "WG";
    }

    if (currentStrap.includes("Bracelet")) {
      currentStrapColor = "bracelet";
    } else if (currentStrap.includes("Blue")) {
      currentStrapColor = "rubberblue";
    } else if (currentStrap.includes("Grey")) {
      currentStrapColor = "rubbergrey";
    }

    if (iframe != null) {
      iframe.contentWindow.postMessage(
        { switchDial: currentDialColor, switchStrap: currentStrapColor },
        "*",
      );
    }
  }

  updateInflectionShuoStickyAtc() {
    const selectedVariableTitle1 = document.querySelector(
      `#sticky-atc-selected-variant-title-1`,
    );

    const selectedVariableColor1 = document.querySelector(
      `#sticky-atc-selected-variant-color-1`,
    );

    const selectedVariableTitle2 = document.querySelector(
      `#sticky-atc-selected-variant-title-2`,
    );

    const selectedVariableColor2 = document.querySelector(
      `#sticky-atc-selected-variant-color-2`,
    );

    if (
      selectedVariableTitle1 != null &&
      selectedVariableColor1 &&
      selectedVariableTitle2 != null &&
      selectedVariableColor2
    ) {
      const variantTittleArr = this.currentVariant.title.split(" / ");

      const dialTitle = variantTittleArr[0];
      const strapTitle = variantTittleArr[1];

      if (dialTitle.includes("Rose")) {
        selectedVariableTitle1.innerHTML = "Rose Gold";
        selectedVariableColor1.style.background = "#E9AD87";
        selectedVariableColor1.classList.remove(
          "sticky-atc-selected-variant-soldout",
        );
      } else {
        selectedVariableTitle1.innerHTML = "White Gold";
        selectedVariableColor1.style.background = " #CDCDCD";
        selectedVariableColor1.classList.remove(
          "sticky-atc-selected-variant-soldout",
        );
      }

      if (strapTitle.includes("Tantalum")) {
        selectedVariableTitle2.innerHTML = "Tantalum Bracelet";
        selectedVariableColor2.style.background = "#797979";
      } else if (strapTitle.includes("Blue")) {
        selectedVariableTitle2.innerHTML = "FKM Sailcloth Strap - Blue";
        selectedVariableColor2.style.background = "#144B9C";
      } else if (strapTitle.includes("Grey")) {
        selectedVariableTitle2.innerHTML = "FKM Sailcloth Strap - Grey";
        selectedVariableColor2.style.background = "#4D4D4D";
      }
    }
  }

  updateInflectionShuoStrapDropdown() {
    const selectedVariableTitle = document.querySelector(
      "#variants-inflection-strap-selector-title",
    );

    const selectedVariableLableIcon = document.querySelector(
      "#variants-inflection-strap-selector-title",
    );

    if (selectedVariableTitle != null) {
      const variantTittleArr = this.currentVariant.title.split(" / ");
      const strapTitle = variantTittleArr[1];
      selectedVariableTitle.innerHTML = strapTitle;

      if (strapTitle.toLowerCase().includes("bracelet")) {
        selectedVariableLableIcon.className = "";
        selectedVariableLableIcon.classList.add(
          "inflection-strap-dropdown-bg-1",
        );
      } else if (strapTitle.toLowerCase().includes("blue")) {
        selectedVariableLableIcon.className = "";
        selectedVariableLableIcon.classList.add(
          "inflection-strap-dropdown-bg-3",
        );
      } else {
        selectedVariableLableIcon.className = "";
        selectedVariableLableIcon.classList.add(
          "inflection-strap-dropdown-bg-4",
        );
      }
    }
  }

  updateInflectionShuoFormText() {
    return new Promise((resolve) => {
      const existing = document.querySelector(
        '[data-testid="klaviyo-form-Xp6Equ"]',
      );

      if (existing) {
        const form = document.querySelector(
          '[data-testid="klaviyo-form-Xp6Equ"]',
        );

        if (!form) return;

        const variantTittleArr = this.currentVariant.title.split(" / ");
        const dialTitle = variantTittleArr[0];
        //const strapTitle = variantTittleArr[1];

        if (dialTitle.includes("White")) {
          const title = form?.querySelector(".klaviyo-form-richtext strong");
          title.innerHTML =
            '<span style="text-transform: uppercase; font-weight: inherit; font-family: inherit;">Sold out. Join the waitlist</span>';
        } else {
          const title = form?.querySelector(".klaviyo-form-richtext strong");
          title.innerHTML = "ENQUIRE ABOUT ALLOCATION";
        }

        resolve(existing);
        return;
      }

      const observer = new MutationObserver(() => {
        const form = document.querySelector(
          '[data-testid="klaviyo-form-Xp6Equ"]',
        );

        if (!form) return;

        const variantTittleArr = this.currentVariant.title.split(" / ");
        const dialTitle = variantTittleArr[0];
        //const strapTitle = variantTittleArr[1];

        if (dialTitle.includes("White")) {
          const title = form?.querySelector(".klaviyo-form-richtext strong");
          title.innerHTML =
            '<span style="text-transform: uppercase; font-weight: inherit; font-family: inherit;">Order window now closed<br>Get notified if available</span>';
        } else {
          const title = form?.querySelector(".klaviyo-form-richtext strong");
          title.innerHTML = "ENQUIRE ABOUT ALLOCATION";
        }

        observer.disconnect();
        resolve(form);
      });

      observer.observe(document.querySelector(".inflection-form"), {
        childList: true,
        subtree: true,
      });
    });
  }

  updatePerceptionFront() {
    const deliveryTag = document.querySelector(".delivery-tag");

    if (!this.currentVariant.available) {
      deliveryTag.style.visibility = "hidden";
      deliveryTag.ariaHidden = true;
    } else {
      deliveryTag.style.visibility = "initial";
      deliveryTag.ariaHidden = false;
    }
  }

  updatePerceptionIFrame() {
    const piao = document.querySelector(`#iframe-piao`);
    const xia = document.querySelector(`#iframe-xia`);
    const ying = document.querySelector(`#iframe-ying`);

    if (this.currentVariant.title.includes("Piao")) {
      piao.src = piao.getAttribute("data-src");
      xia.removeAttribute("src");
      ying.removeAttribute("src");
    } else if (this.currentVariant.title.includes("Xia")) {
      xia.src = xia.getAttribute("data-src");
      piao.removeAttribute("src");
      ying.removeAttribute("src");
    } else {
      ying.src = ying.getAttribute("data-src");
      piao.removeAttribute("src");
      xia.removeAttribute("src");
    }
  }

  updateAncestraIFrame() {
    if (window.ShopifyTemplate.suffix === "ancestra") {
      //if (this.dataset.url == "/products/ancestra-jiao") {
      const chinese = document.querySelector(`#iframe-chinese`);
      const arabic = document.querySelector(`#iframe-arabic`);

      if (this.currentVariant.title.includes("Chinese")) {
        chinese.src = chinese.getAttribute("data-src");
        arabic.removeAttribute("src");
      } else {
        arabic.src = arabic.getAttribute("data-src");
        chinese.removeAttribute("src");
      }
    }
  }

  updateInflectionStrapDropdown() {
    const selectedVariableTitle = document.querySelector(
      "#variants-inflection-strap-selector-title",
    );

    /*
    const selectedVariableImage = document.querySelector(
      "#variants-inflection-strap-selector-image"
    );
    */

    const selectedVariableLableIcon = document.querySelector(
      "#variants-inflection-strap-selector-title",
    );

    if (selectedVariableTitle != null) {
      const variantTittleArr = this.currentVariant.title.split(" / ");
      const strapTitle = variantTittleArr[1];
      selectedVariableTitle.innerHTML = strapTitle;

      /*
      let currentDial = 0;
      if (variantTittleArr[0].includes("Black")) {
        currentDial = 0;
      } else if (variantTittleArr[0].includes("Green")) {
        currentDial = 4;
      } else if (variantTittleArr[0].includes("Blue")) {
        currentDial = 8;
      }

      for (let i = 0; i < 4; i++) {
        const strapImage = document.querySelector(
          "#inflection-dropdown-image-" + i
        );

        if (strapImage != null) {
          strapImage.src =
            this.variantData[currentDial + i].featured_media.preview_image.src;
        }
      }
      */

      if (strapTitle.toLowerCase().includes("bracelet")) {
        selectedVariableLableIcon.className = "";
        selectedVariableLableIcon.classList.add(
          "inflection-strap-dropdown-bg-1",
        );
      } else if (strapTitle.toLowerCase().includes("green")) {
        selectedVariableLableIcon.className = "";
        selectedVariableLableIcon.classList.add(
          "inflection-strap-dropdown-bg-2",
        );
      } else if (strapTitle.toLowerCase().includes("blue")) {
        selectedVariableLableIcon.className = "";
        selectedVariableLableIcon.classList.add(
          "inflection-strap-dropdown-bg-3",
        );
      } else {
        selectedVariableLableIcon.className = "";
        selectedVariableLableIcon.classList.add(
          "inflection-strap-dropdown-bg-4",
        );
      }
    }

    /*
    if (selectedVariableImage != null) {
      selectedVariableImage.src =
        this.currentVariant.featured_media.preview_image.src;
    }
    */
  }

  updateInflectionPrice() {
    const hostname = window.location.hostname;

    // ROW uses Shopify-rendered prices to preserve the active presentment currency.
    if (hostname === "int.atelierwen.com") return;

    const prices = document.querySelectorAll(".product-content .price-item");
    const stickyPrices = document.querySelectorAll(
      ".sticky-container .price-item",
    );

    if (hostname == "atelierwen.com") {
      const price = new Intl.NumberFormat("en-HK", {
        style: "currency",
        currency: "HKD",
      }).format(this.currentVariant.price * 0.01);

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    } else if (hostname == "us.atelierwen.com") {
      const price =
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(this.currentVariant.price * 0.01) + " USD";

      prices.forEach((p) => {
        p.innerHTML = price;
      });

      stickyPrices.forEach((sp) => {
        sp.innerHTML = price;
      });
    } else if (hostname == "sg.atelierwen.com") {
      const price =
        new Intl.NumberFormat("en-SG", {
          style: "currency",
          currency: "SGD",
        }).format(this.currentVariant.price * 0.01) + " SGD";

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    } else if (hostname == "eu.atelierwen.com") {
      const price =
        new Intl.NumberFormat("en-FR", {
          style: "currency",
          currency: "EUR",
        }).format(this.currentVariant.price * 0.01) + " EUR";

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    } else {
      const price = new Intl.NumberFormat("en-HK", {
        style: "currency",
        currency: "HKD",
      }).format(this.currentVariant.price * 0.01);

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    }
  }

  formatEuroCustom(amountInCents) {
    const sign = amountInCents < 0 ? "-" : "";
    const absoluteCents = Math.abs(amountInCents);

    const euros = Math.floor(absoluteCents / 100);
    const cents = absoluteCents % 100;

    const groupedEuros = String(euros).replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    const centsPart = String(cents).padStart(2, "0");

    return `${sign}€${groupedEuros},${centsPart} EUR`;
  }

  updateInflectionTantalumBasedPrice() {
    const hostname = window.location.hostname;

    // ROW uses Shopify-rendered prices to preserve the active presentment currency.
    if (hostname === "int.atelierwen.com") return;

    const prices = document.querySelectorAll(".product-content .price-item");
    const stickyPrices = document.querySelectorAll(
      ".sticky-container .price-item",
    );

    const variantTittleArr = this.currentVariant.title.split(" / ");
    const dialTitle = variantTittleArr[0];

    let tantalumPrice = 0;

    if (dialTitle.includes("Black")) {
      tantalumPrice = this.variantData[0].price;
    } else if (dialTitle.includes("Blue")) {
      tantalumPrice = this.variantData[4].price;
    } else if (dialTitle.includes("Green")) {
      tantalumPrice = this.variantData[8].price;
    } else {
      tantalumPrice = this.variantData[0].price;
    }

    if (hostname == "atelierwen.com") {
      const price = new Intl.NumberFormat("en-HK", {
        style: "currency",
        currency: "HKD",
      }).format(tantalumPrice * 0.01);

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    } else if (hostname == "us.atelierwen.com") {
      const price =
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(tantalumPrice * 0.01) + " USD";

      prices.forEach((p) => {
        p.innerHTML = price;
      });

      stickyPrices.forEach((sp) => {
        sp.innerHTML = price;
      });
    } else if (hostname == "sg.atelierwen.com") {
      const price =
        new Intl.NumberFormat("en-SG", {
          style: "currency",
          currency: "SGD",
        }).format(tantalumPrice * 0.01) + " SGD";

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    } else if (hostname == "eu.atelierwen.com") {
      /*
      const price =
        new Intl.NumberFormat("en-FR", {
          style: "currency",
          currency: "EUR",
        }).format(tantalumPrice * 0.01) + " EUR";
      */
      const price = this.formatEuroCustom(tantalumPrice);

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    } else {
      const price = new Intl.NumberFormat("en-HK", {
        style: "currency",
        currency: "HKD",
      }).format(tantalumPrice * 0.01);

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    }
  }

  updateInflectionSoldout() {
    const inflectionSoldout = document.querySelector(".inflection-soldout");
    const inflectionForm = document.querySelector(".inflection-form");

    const variantTittleArr = this.currentVariant.title.split(" / ");

    const dialTitle = variantTittleArr[0];

    if (inflectionSoldout != null && inflectionForm != null) {
      if (dialTitle.includes("Black") || dialTitle.includes("Blue")) {
        inflectionSoldout.classList.add("hide-soldout");
        inflectionForm.classList.remove("hide-form");
      } else {
        inflectionSoldout.classList.remove("hide-soldout");
        inflectionForm.classList.add("hide-form");
      }
    }
  }

  updatePerceptionV3Price() {
    const hostname = window.location.hostname;

    // ROW uses Shopify-rendered prices to preserve the active presentment currency.
    if (hostname === "int.atelierwen.com") return;

    const prices = document.querySelectorAll(".product-content .price-item");
    const stickyPrices = document.querySelectorAll(
      ".sticky-container .price-item",
    );

    if (hostname == "atelierwen.com") {
      const price = new Intl.NumberFormat("en-HK", {
        style: "currency",
        currency: "HKD",
      }).format(this.currentVariant.price * 0.01);

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    } else if (hostname == "us.atelierwen.com") {
      const price =
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(this.currentVariant.price * 0.01) + " USD";

      prices.forEach((p) => {
        p.innerHTML = price;
      });

      stickyPrices.forEach((sp) => {
        sp.innerHTML = price;
      });
    } else if (hostname == "sg.atelierwen.com") {
      const price =
        new Intl.NumberFormat("en-SG", {
          style: "currency",
          currency: "SGD",
        }).format(this.currentVariant.price * 0.01) + " SGD";

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    } else if (hostname == "eu.atelierwen.com") {
      const price =
        new Intl.NumberFormat("en-FR", {
          style: "currency",
          currency: "EUR",
        }).format(this.currentVariant.price * 0.01) + " EUR";

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    } else {
      const price = new Intl.NumberFormat("en-HK", {
        style: "currency",
        currency: "HKD",
      }).format(this.currentVariant.price * 0.01);

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    }
  }

  updatePerceptionV3Info() {
    const variantTitle = document.querySelector(`.perception-v3-variant-title`);
    const variantTitleSm = document.querySelector(
      `.perception-v3-variant-title-sm`,
    );

    const variantinfo = document.querySelector(`.perception-v3-variant-info`);

    if (variantTitle != null && variantinfo != null && variantTitleSm != null) {
      if (
        this.currentVariant.title.includes("Yun") ||
        this.currentVariant.title.includes("Yún")
      ) {
        variantTitle.innerHTML = "Yún 筠 (Green)";
        variantTitleSm.innerHTML = "Yún 筠 (Green)";
        variantinfo.innerHTML =
          "904L Stainless Steel, Micro-frosted & Mirror Polished";
      } else if (
        this.currentVariant.title.includes("Piao") ||
        this.currentVariant.title.includes("Piāo")
      ) {
        variantTitle.innerHTML = "Piāo 缥 (Ice Blue)";
        variantTitleSm.innerHTML = "Piāo 缥 (Ice Blue)";
        variantinfo.innerHTML =
          "904L Stainless Steel, Brushed & Mirror Polished";
      } else {
        variantTitle.innerHTML = "Xiá 霞 (Salmon)";
        variantTitleSm.innerHTML = "Xiá 霞 (Salmon)";
        variantinfo.innerHTML =
          "904L Stainless Steel, Brushed & Mirror Polished";
      }
    }
  }

  updatePrice() {
    const hostname = window.location.hostname;

    // ROW uses Shopify-rendered prices to preserve the active presentment currency.
    if (hostname === "int.atelierwen.com") return;

    const prices = document.querySelectorAll(".product-content .price-item");
    const stickyPrices = document.querySelectorAll(
      ".sticky-container .price-item",
    );

    if (hostname == "atelierwen.com") {
      const price = new Intl.NumberFormat("en-HK", {
        style: "currency",
        currency: "HKD",
      }).format(this.currentVariant.price * 0.01);

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    } else if (hostname == "us.atelierwen.com") {
      const price =
        new Intl.NumberFormat("en-US", {
          style: "currency",
          currency: "USD",
        }).format(this.currentVariant.price * 0.01) + " USD";

      prices.forEach((p) => {
        p.innerHTML = price;
      });

      stickyPrices.forEach((sp) => {
        sp.innerHTML = price;
      });
    } else if (hostname == "sg.atelierwen.com") {
      const price =
        new Intl.NumberFormat("en-SG", {
          style: "currency",
          currency: "SGD",
        }).format(this.currentVariant.price * 0.01) + " SGD";

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    } else if (hostname == "eu.atelierwen.com") {
      const price =
        new Intl.NumberFormat("en-FR", {
          style: "currency",
          currency: "EUR",
        }).format(this.currentVariant.price * 0.01) + " EUR";

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    } else {
      const price = new Intl.NumberFormat("en-HK", {
        style: "currency",
        currency: "HKD",
      }).format(this.currentVariant.price * 0.01);

      if (prices != null) {
        prices.forEach((p) => {
          p.innerHTML = price;
        });
      }

      if (price != null) {
        stickyPrices.forEach((sp) => {
          sp.innerHTML = price;
        });
      }
    }
  }

  updateStickyAtc() {
    const selectedVariableTitle = document.querySelector(
      `#sticky-atc-selected-variant-title`,
    );

    const selectedVariableColor = document.querySelector(
      `#sticky-atc-selected-variant-color`,
    );

    if (selectedVariableTitle != null && selectedVariableColor) {
      //if (this.dataset.url == "/products/perception") {
      if (window.ShopifyTemplate.suffix === "perception") {
        if (this.currentVariant.title.includes("Piao")) {
          selectedVariableTitle.innerHTML = "Piao";
          selectedVariableColor.style.background = " #144b9c";
        } else if (this.currentVariant.title.includes("Xia")) {
          selectedVariableTitle.innerHTML = "Xia";
          selectedVariableColor.style.background = "#ee7878";
        } else {
          selectedVariableTitle.innerHTML = "Ying";
          selectedVariableColor.style.background = "#252525";
        }
      }

      if (window.ShopifyTemplate.suffix === "perception-v3") {
        if (
          this.currentVariant.title.includes("Yun") ||
          this.currentVariant.title.includes("Yún")
        ) {
          selectedVariableTitle.innerHTML = "Yún";
          selectedVariableColor.style.background = "#31c3a6";
        } else if (
          this.currentVariant.title.includes("Piao") ||
          this.currentVariant.title.includes("Piāo")
        ) {
          selectedVariableTitle.innerHTML = "Piāo";
          selectedVariableColor.style.background = "#144b9c";
        } else {
          selectedVariableTitle.innerHTML = "Xiá";
          selectedVariableColor.style.background = "#ee7878";
        }
      }

      if (window.ShopifyTemplate.suffix === "inflection-shuo") {
        if (this.currentVariant.title.includes("Rose")) {
          selectedVariableTitle.innerHTML = "Rose Gold";
          selectedVariableColor.style.background = "#e6b7a9";
        } else if (this.currentVariant.title.includes("White")) {
          selectedVariableTitle.innerHTML = "White Gold";
          selectedVariableColor.style.background = "#e6e6e6";
        } else {
        }
      }

      //if (this.dataset.url == "/products/ancestra-jiao") {
      if (window.ShopifyTemplate.suffix === "ancestra") {
        if (this.currentVariant.title.includes("Chinese")) {
          selectedVariableTitle.innerHTML = "Chinese";
          selectedVariableColor.classList.remove("ancestra-label-bg-2");
          selectedVariableColor.classList.add("ancestra-label-bg-1");
        } else {
          selectedVariableTitle.innerHTML = "Arabic";
          selectedVariableColor.classList.remove("ancestra-label-bg-1");
          selectedVariableColor.classList.add("ancestra-label-bg-2");
        }
      }

      //if (this.dataset.url == "/products/fkm-rubber-straps") {
      if (window.ShopifyTemplate.suffix === "fkm-rubber-strap") {
        if (this.currentVariant.title.includes("White")) {
          selectedVariableTitle.innerHTML = "White";
          selectedVariableColor.style.background = "#FFF";
        } else if (this.currentVariant.title.includes("Blue")) {
          selectedVariableTitle.innerHTML = "Blue";
          selectedVariableColor.style.background = "#2b51ff";
        } else if (this.currentVariant.title.includes("Grey")) {
          selectedVariableTitle.innerHTML = "Grey";
          selectedVariableColor.style.background = "#797979";
        } else {
          selectedVariableTitle.innerHTML = "Black";
          selectedVariableColor.style.background = "#000";
        }
      }
    }
  }

  updateInflectionStickyAtc() {
    const selectedVariableTitle1 = document.querySelector(
      `#sticky-atc-selected-variant-title-1`,
    );

    const selectedVariableColor1 = document.querySelector(
      `#sticky-atc-selected-variant-color-1`,
    );

    const selectedVariableTitle2 = document.querySelector(
      `#sticky-atc-selected-variant-title-2`,
    );

    const selectedVariableColor2 = document.querySelector(
      `#sticky-atc-selected-variant-color-2`,
    );

    if (
      selectedVariableTitle1 != null &&
      selectedVariableColor1 &&
      selectedVariableTitle2 != null &&
      selectedVariableColor2
    ) {
      const variantTittleArr = this.currentVariant.title.split(" / ");

      const dialTitle = variantTittleArr[0];
      const strapTitle = variantTittleArr[1];

      if (dialTitle.includes("Black")) {
        selectedVariableTitle1.innerHTML = "墨 (Mò)";
        selectedVariableColor1.style.background = "#000";
        selectedVariableColor1.classList.remove(
          "sticky-atc-selected-variant-soldout",
        );
      } else if (dialTitle.includes("Green")) {
        selectedVariableTitle1.innerHTML = "幽 (Yōu)";
        selectedVariableColor1.style.background = " #3AAB47";
        selectedVariableColor1.classList.add(
          "sticky-atc-selected-variant-soldout",
        );
      } else {
        selectedVariableTitle1.innerHTML = "渊 (Yuān)";
        selectedVariableColor1.style.background = " #2A51FF";
        selectedVariableColor1.classList.remove(
          "sticky-atc-selected-variant-soldout",
        );
      }

      if (strapTitle.includes("Tantalum")) {
        selectedVariableTitle2.innerHTML = "Tantalum Bracelet";
        selectedVariableColor2.style.background = "#797979";
      } else if (strapTitle.includes("Green")) {
        selectedVariableTitle2.innerHTML = "FKM Sailcloth Strap - Green";
        selectedVariableColor2.style.background = "#149C16";
      } else if (strapTitle.includes("Blue")) {
        selectedVariableTitle2.innerHTML = "FKM Sailcloth Strap - Blue";
        selectedVariableColor2.style.background = "#144B9C";
      } else if (strapTitle.includes("Grey")) {
        selectedVariableTitle2.innerHTML = "FKM Sailcloth Strap - Grey";
        selectedVariableColor2.style.background = "#4D4D4D";
      }
    }
  }

  updateInflectionTitle() {
    const title = document.querySelectorAll(".inflection-caption");
    const variantTittleArr = this.currentVariant.title.split(" / ");
    const dialTitle = variantTittleArr[0];

    if (title != null) {
      title.forEach((t) => {
        if (dialTitle.includes("Green")) {
          t.innerHTML = "Green 幽 (Yōu) - Launch (Limited) Edition";
        } else if (dialTitle.includes("Black")) {
          t.innerHTML = "Black 墨 (Mò) - Permanent Collection";
        } else {
          t.innerHTML = "Blue 渊 (Yuān) - Permanent Collection";
        }
      });
    }
  }

  updateInflectionMailForm() {
    /*
    const klaviyoForm = document.querySelector(
      '[data-testid="klaviyo-form-Y2RNTx"]'
    );
    if (!klaviyoForm) return;
    
    const formInput = klaviyoForm.querySelector('input[name="variants"]');

    if (formInput != null) {
      formInput.value = this.currentVariant.title;
    }
    */
    /*
    const formInput = document.getElementById("current-selected-variants");

    if (formInput != null) {
      formInput.value = this.currentVariant.title;
    }
    */

    const inflectionVariantRadio = document.getElementById(
      "variant-radios-inflection",
    );

    if (inflectionVariantRadio != null) {
      inflectionVariantRadio.dataset.variants = this.currentVariant.title;
    }
  }

  updatePerceptionMailForm() {
    const perceptionVariantRadio = document.getElementById(
      "variant-radios-perception",
    );

    if (perceptionVariantRadio != null) {
      perceptionVariantRadio.dataset.variants = this.currentVariant.title;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`,
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`,
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-${this.dataset.section}-sticky`,
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1,
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [
        ...option.querySelectorAll('input[type="radio"], option'),
      ];
      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected,
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value"),
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  updateLocalizedPrices(html, source) {
    const section = document.getElementById(
      `shopify-section-${this.dataset.section}`,
    );
    if (!section) return;

    // Desktop and mobile price wrappers share an ID in the product templates.
    if (source) {
      section
        .querySelectorAll(`[id="price-${this.dataset.section}"]`)
        .forEach((price) => {
          price.innerHTML = source.innerHTML;
          price.classList.remove("visibility-hidden");
        });
    }

    // Keep the sticky price's own Liquid pricing rules, including sale/unit prices.
    const stickySource = html.querySelector(".sticky-container .price");
    if (stickySource) {
      section.querySelectorAll(".sticky-container .price").forEach((price) => {
        price.innerHTML = stickySource.innerHTML;
        price.className = stickySource.className;
      });
    }
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`,
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`,
        );
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const skuDestination = document.getElementById(
          `Sku-${this.dataset.section}`,
        );
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`,
        );
        const inventoryDestination = document.getElementById(
          `Inventory-${this.dataset.section}`,
        );

        if (window.location.hostname === "int.atelierwen.com") {
          this.updateLocalizedPrices(html, source);
        } else if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle(
            "visibility-hidden",
            skuSource.classList.contains("visibility-hidden"),
          );
        }
        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle(
            "visibility-hidden",
            inventorySource.innerText === "",
          );

        const stock = document.getElementById("product__stock");

        /*
        if (
          this.dataset.url != "/products/perception" ||
          this.dataset.url != "/products/fkm-rubber-straps" ||
          this.dataset.url != "/products/metal-bracelet"
        )*/
        if (
          window.ShopifyTemplate.suffix === "perception" ||
          window.ShopifyTemplate.suffix === "fkm-rubber-strap" ||
          window.ShopifyTemplate.suffix === "metal-bracelet"
        ) {
          if (this.currentVariant.available) {
            stock.innerText = "In Stock";
          } else {
            stock.innerText = "Out of Stock";
          }
        }

        /*
        if (this.dataset.url != "/products/fkm-rubber-straps") {
          if (this.currentVariant.available) {
            stock.innerText = "In Stock";
          } else {
            stock.innerText = "Out of Stock";
          }
        }
        */
        /*
        if (this.dataset.url == "/products/perception") {
          this.toggleAddButton(
            !this.currentVariant.available,
            "Join the Waiting List"
          );
        } else */

        /*
        if (
          this.dataset.url == "/products/porcelain-odyssey-hao" ||
          this.dataset.url == "/products/porcelain-odyssey-ji"
        )*/

        if (
          window.ShopifyTemplate.suffix === "porcelain-odyssey-hao" ||
          window.ShopifyTemplate.suffix === "porcelain-odyssey-ji"
        ) {
          this.toggleAddButton(
            !this.currentVariant.available,
            "Permanently retired",
          );
        } else {
          this.toggleAddButton(
            !this.currentVariant.available,
            window.variantStrings.soldOut,
          );
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      /*
      if (this.dataset.url == "/products/perception") {
        addButton.setAttribute(
          "onClick",
          "window.open('https://forms.gle/3oGU7xrftp6KWi7a6','_blank')"
        );
      } else {
        addButton.setAttribute("disabled", "disabled");
      }
      */
      addButton.setAttribute("disabled", "disabled");

      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");

      /*
      if (this.dataset.url == "/products/perception") {
        addButton.removeAttribute(
          "onClick",
          "window.open('https://forms.gle/3oGU7xrftp6KWi7a6','_blank')"
        );
      }
      */

      //addButtonText.textContent = window.variantStrings.addToCart;
      //addButton.setAttribute("type", "submit");

      /*
      if (
        this.dataset.url == "/products/perception" ||
        this.dataset.url == "/products/fkm-rubber-straps"
      ) {
        addButtonText.textContent = "Place Deposit (30%)";
      } else {
        addButtonText.textContent = "Add to cart";
      }
      */

      addButtonText.textContent = "Add to cart";
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`,
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(
      `Inventory-${this.dataset.section}`,
    );
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
    if (inventory) inventory.classList.add("visibility-hidden");
    if (sku) sku.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  // Add for video state.
  updateVideoState() {
    document.querySelectorAll("video").forEach((e) => {
      e.play();
    });
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    //const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    const fieldsets = Array.from(this.querySelectorAll(".variants-selector"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked,
      ).value;
    });

    // For sticky ATC Button
    const selectorSticky = document.querySelectorAll(
      ".variants-selector-sticky",
    );

    if (selectorSticky != null) {
      const fieldsetsSticky = Array.from(
        document.querySelectorAll(".variants-selector-sticky"),
      );

      fieldsetsSticky.map((fieldsetSticky) => {
        fieldsetSticky.querySelectorAll("input").forEach((v) => {
          if (v.value == this.options) {
            v.checked = true;
          }
        });

        fieldsetSticky.style.display = "none";
      });
    }

    // For Inflection Strap Selector
    const selectorInflectionStrap = document.querySelector(
      ".variants-inflection-strap-selector",
    );

    if (selectorInflectionStrap != null) {
      const fieldsetsSticky = Array.from(
        document.querySelectorAll(".variants-inflection-strap-selector"),
      );

      fieldsetsSticky.map((fieldsetSticky) => {
        fieldsetSticky.querySelectorAll("input").forEach((v) => {
          if (v.value == this.options) {
            v.checked = true;
          }
        });

        fieldsetSticky.style.display = "none";
      });
    }
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);
